import moment from "moment";
import React, { useState } from "react";
import { CSVLink } from "react-csv";
import { Share2, XCircle } from "react-feather";
import TouchCanvas from "../components/TouchCanvas";
import { useBodyScrollLock } from "../hooks/useBodyScrollLock";
import { TouchPoint } from "../types";

function App() {
  const [touches, setTouches] = useState<TouchPoint[]>();
  const [minSpeed, setMinSpeed] = useState<number>();
  const [maxSpeed, setMaxSpeed] = useState<number>();
  const [colors, setColors] = useState([-1, -1, -1, -1, -1]);

  useBodyScrollLock();

  const clear = () => {
    setTouches([]);
    setMinSpeed(undefined);
    setMaxSpeed(undefined);
    setColors([-1, -1, -1, -1, -1]);
  };

  const getDataFromTouches = () => {
    let data: {
      event: string;
      id: number;
      x: number;
      y: number;
      timestamp: number;
      radius: number;
    }[] = [];

    if (touches) {
      touches.forEach((touchPoint) => {
        data.push({
          id: touchPoint.colorId,
          event: touchPoint.event,
          x: touchPoint.x,
          y: touchPoint.y,
          radius: touchPoint.rx,
          timestamp: touchPoint.timestamp,
        });
      });
    }
    return data;
  };

  const getFileExportName = () => {
    let date = moment().format("YYYYMMDD_HHmm");
    return "toxto_" + date + ".csv";
  };

  return (
    <div className="w-screen h-screen overflow-hidden no-text-select no-user-interaction">
      <TouchCanvas
        touches={touches}
        setTouches={setTouches}
        minSpeed={minSpeed}
        setMinSpeed={setMinSpeed}
        maxSpeed={maxSpeed}
        setMaxSpeed={setMaxSpeed}
        colors={colors}
        setColors={setColors}
      />
      <div className="absolute top-0 w-screen">
        <nav className="flex flex-row items-center justify-between w-full p-2 space-x-4 text-gray-900 bg-white border-b-2 border-prismade-blue">
          <CSVLink
            data={getDataFromTouches()}
            filename={getFileExportName()}
            className="inline-flex items-center space-x-1"
            target="_blank"
          >
            <div className="font-semibold">Export</div>
            <span className="text-gray-600">
              <Share2 size="20" />
            </span>
          </CSVLink>
          <button
            onClick={clear}
            className="inline-flex items-center space-x-1"
          >
            <div className="font-semibold">Clear</div>
            <span className="text-gray-600">
              <XCircle size="20" />
            </span>
          </button>
        </nav>
      </div>
    </div>
  );
}

export default App;
